import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { ClientPortalService } from '../services/client-portal.service';

@Component({
  selector: 'app-client-portal-login',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
  templateUrl: './client-portal-login.component.html',
  styleUrls: ['./client-portal-login.component.css']
})
export class ClientPortalLoginComponent {
  email = '';
  password = '';
  loginError = false;
  loginClientMismatch = false;
  loading = false;

  view: 'login' | 'forgot' | 'sent' = 'login';
  forgotEmail = '';
  forgotLoading = false;
  forgotError = false;
  emailTestMode = false;
  testEmailSendToAddress: string | null = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private portalService: ClientPortalService
  ) {}

  login() {
    if (!this.email.trim() || !this.password.trim()) return;
    this.loginError = false;
    this.loginClientMismatch = false;
    this.loading = true;
    this.http.post<{ clients: { id: number; name: string }[]; contactName: string; token: string }>(
      '/charitycentral/ClientPortalLogin',
      { email: this.email, password: this.password }
    ).subscribe({
      next: (result) => {
        const expectedClientIdStr = this.route.snapshot.queryParamMap.get('clientId');
        if (expectedClientIdStr) {
          const expectedClientId = +expectedClientIdStr;
          if (!result.clients.some(c => c.id === expectedClientId)) {
            this.loginClientMismatch = true;
            this.loading = false;
            return;
          }
          this.portalService.setSession(result.clients, result.contactName, result.token, expectedClientId, false);
          const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
          if (returnUrl && returnUrl.startsWith(`/client/${expectedClientId}`)) {
            this.router.navigateByUrl(returnUrl);
          } else {
            this.router.navigate(['/client', expectedClientId]);
          }
        } else {
          const firstClientId = result.clients[0].id;
          const multiClientMode = result.clients.length > 1;
          this.portalService.setSession(result.clients, result.contactName, result.token, firstClientId, multiClientMode);
          this.router.navigate(['/client', firstClientId]);
        }
      },
      error: () => {
        this.loginError = true;
        this.loading = false;
      }
    });
  }

  showForgot() {
    this.view = 'forgot';
    this.forgotEmail = '';
    this.forgotError = false;
    this.http.get<{ testMode: boolean; testEmailSendToAddress: string | null }>(
      '/charitycentral/GetEmailTestModeSettings'
    ).subscribe({
      next: (s) => {
        this.emailTestMode = s.testMode;
        this.testEmailSendToAddress = s.testEmailSendToAddress;
      },
      error: () => {}
    });
  }

  submitForgotPassword() {
    if (!this.forgotEmail.trim()) return;
    this.forgotLoading = true;
    this.forgotError = false;
    this.http.post('/charitycentral/RequestClientPasswordReset', { email: this.forgotEmail }).subscribe({
      next: () => {
        this.forgotLoading = false;
        this.view = 'sent';
      },
      error: () => {
        this.forgotLoading = false;
        this.forgotError = true;
      }
    });
  }
}
